module.exports = "https://static.wmbcdn.com/uniweb/images/255fd0289156900508ddf15a9c729fc5.svg";